<template>
  <div class="diadin">
    <div class="title">
      <div class="title_1">{{ $t('menu.Basicinformation')  }}</div>
    </div>
    <div class="tbox">
      <div class="tbox-title">{{ $t('menu.UserName') }}</div>
      <div>
        {{ userinfo.userName }}
        <!-- <span style="color: #409eff; cursor: pointer; margin-left: 20px" @click="dialogVisible = true">修改</span> -->
      </div>
    </div>
    <div class="tbox">
      <div class="tbox-title">{{ $t('menu.EmailAddress') }}</div>
      <div>{{ userinfo.email }}</div>
    </div>
    <div class="tbox">
      <div class="tbox-title" v-if="tup=='1'">{{ $t('menu.Distributor') }}</div>
      <div class="tbox-title" v-else>{{ $t('menu.zcmxlsh') }}</div>
      <div v-if="userinfo.dealers[0] !== undefined">{{ userinfo.dealers[0].dealerName }}</div>
    </div>
    <div class="tbox">
      <div class="tbox-title">{{ $t('menu.Role') }}</div>
      <div v-if="userinfo.roles[0] !== undefined">{{ userinfo.roles[0].roleName }}</div>
    </div>
    <div class="tbox">
      <div class="tbox-title">{{ $t('menu.Password') }}</div>
      <div style="color: #409eff; cursor: pointer" @click="dialogVisiblea = true">{{ $t('menu.ChangePassword') }}</div>
    </div>

    <el-dialog title="修改名称" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div style="width: 60%;margin: 40px auto;">
        <el-input v-model="input" :placeholder="userinfo.nickName"></el-input>
        <div style="margin: 0 auto;margin-top: 40px;width: 200px;">
          <el-button type="primary" style="width: 200px;" @click="usernamea">{{ $t('menu.Confirm') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="$t('menu.ChangePassword')" :visible.sync="dialogVisiblea" width="30%"
      :before-close="handleClose">
      <div style="width: 60%;margin: 40px auto;">
        <el-input v-model="pasword" :placeholder="$t('menu.Inputthepassword')"></el-input>
        <div style="margin: 0 auto;margin-top: 40px;width: 200px;">
          <el-button type="primary" style="width: 200px;" @click="paswder()">{{ $t('menu.Confirm') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getInfo, userproname, userupdatePwde } from "../../api/api";
import axios from 'axios'
export default {
  data () {
    return {
      userinfo: {
        userName: ''
      },
      input: '',
      dialogVisible: false,
      dialogVisiblea: false,
      pasword: '',
      tup:'1',
    };
  },
  created () {
    this.biao();
    this.tup=sessionStorage.getItem('platform')
  },
  methods: {
    async biao () {
      let param = new URLSearchParams();
      const { data: res } = await getInfo(param);
      console.log(6666666, res)
      this.userinfo = res.user;
     
      
    },
    async usernamea () {
      let param = {
        userName: this.input,
        nickName: this.input,
      }
      const { data: res } = await userproname(param);
      this.$message({
        message: this.$t('menu.caozuochengong'),
        type: 'success'
      });

      this.dialogVisible = false
      this.biao()
      sessionStorage.setItem("name", this.input)
    },
    async paswder () {
            // let param = {
        // oldPassword: this.userinfo.password,
  let param = new URLSearchParams();
  param.append("newPassword", this.pasword);
      //     newPassword: this.pasword
      // }
      axios({
          method: 'put',
         
          // url:'http://fdms-test.bendamotor.cn/bendaFDMSTestWeb/system/user/profile/updatePwd',
          url:this.common.httpUrl+'/system/user/profile/updatePwd',
          data: param,
          headers: { 'content-type': 'application/x-www-form-urlencoded' ,'authorization':sessionStorage.getItem('token')},
         }).then((res) => {
          if (res.data.code == 200) {
        this.$message({
          message:this.$t('menu.caozuochengong'),
          type: 'success'
        });
        this.dialogVisiblea = false
        this.biao()
      } else {
        this.$message.error(res.data.msg);

      }
              
                  }) 
            


    
     
  //     const { data: res } = await userupdatePwde(param);
  //     if (res.code == 200) {
  //       this.$message({
  //         message: '操作成功',
  //         type: 'success'
  //       });
  //       this.dialogVisiblea = false
  //       this.biao()
  //     } else {
  //       this.$message.error(res.msg);

  //     }



      // sessionStorage.setItem("name", this.input)
    },

    handleClose (done) {
      this.input = ''
      this.pasword = ''
      this.dialogVisible = false
      this.dialogVisiblea = false
      done();

    }
  },
};
</script>


<style lang="less" scoped>
.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.title {
  width: 100%;
  border-bottom: 1px solid #f2f2f2;
  padding: 20px 0;
  display: flex;
  margin-bottom: 30px;
  align-items: center;
  justify-content: space-between;
}

.title_1 {
  padding-left: 15px;
  border-left: 5px solid #409eff;
}

.tbox {

  padding-left: 20px;
  font-size: 18px;
  margin-bottom: 60px;
}

.tbox-title {
  width: 300px;
  margin-bottom: 10px;
}
</style>